// extracted by mini-css-extract-plugin
export default {"badge":"badge_badge__Uj949","primary":"badge_primary__eV5ip","warning":"badge_warning__nTKp7","danger":"badge_danger__YCj8U","icon":"badge_icon__QiEmO"};